import { useMemo } from 'react'
import { useField } from 'formik'
import { useAppTranslations } from '../../../../utils/hooks/useAppTranslations'
import mapEnumForSelect from '../../../../utils/mapEnumForSelect'
import { useUserPermissions } from '../../../company/userPermissions'
import type { LocationTypeOption } from '../../../../components/form/geoLocationsPanel/LocationsRuleBar'
import { LocationTypesEnum } from './GeoTargetingFields'

/** The location types offered for the rule in the form; LocationTypesEnum is only read at call time (import cycle) */
export const useLocationTypeOptions = (hasInitialExcludedCountries = false): LocationTypeOption[] => {
  const t = useAppTranslations()
  const { superAdmin } = useUserPermissions()
  const [, targetingTypeField] = useField('targeting.geoExclusive')

  return useMemo(
    () =>
      mapEnumForSelect(LocationTypesEnum)
        .filter(
          (locationType) =>
            locationType.value !== LocationTypesEnum.Countries ||
            targetingTypeField?.value === true ||
            hasInitialExcludedCountries ||
            superAdmin // Allow "Countries" if geoExclusive is true in form, if initial targeting excludes countries, or user is superAdmin
        )
        .map((type) => ({
          value: type.value as LocationTypesEnum,
          label: t(`adgroup.geoTargeting.${type.value}`),
        })),
    [targetingTypeField.value, hasInitialExcludedCountries, superAdmin, t]
  )
}
